// Flight-pad helpers — read normalized FlightOffer fields only
// (see providers/index.js typedef). Provider-agnostic.

import { count_adults } from '@liveflight/providers';

export const carrier_iata = (itinerary, segment_index = 0) => {
  const { segments = [] } = itinerary || {};
  const index = segments.length <= segment_index ? 0 : segment_index;
  const { carrier = {} } = segments[index] || {};
  return carrier.code || '';
};

export const bags_quantity_color = (quantity = 0, active_color = '#39414E') =>
  quantity > 0 ? active_color : '#AAAAAA';

/**
 * Minimum bag quantity across all segments of travelerPricings[0], so a
 * per-leg allowance split never over-promises the worse leg. 0 when the
 * offer carries no fare detail.
 *
 * @param {object} flight_offer
 * @param {(fare_detail: object) => number} read_quantity
 * @returns {number}
 */
const min_bags_across_segments = (flight_offer, read_quantity) => {
  const { travelerPricings = [] } = flight_offer || {};
  const { fareDetailsBySegment = [] } = travelerPricings[0] || {};
  if (fareDetailsBySegment.length === 0) {
    return 0;
  }
  return Math.min(...fareDetailsBySegment.map(read_quantity));
};

// Boolean presence indicator (1 when the offer has any adult, else 0).
// Per-adult multiplication happens on the sidebar resume row.
export const hand_bags_per_adult = (flight_offer) =>
  count_adults(flight_offer) > 0 ? 1 : 0;

export const luggage_bags_per_adult = (flight_offer) =>
  min_bags_across_segments(flight_offer, (fare_detail) => {
    const { includedCheckedBags = {} } = fare_detail || {};
    return includedCheckedBags.quantity || 0;
  });

export const cabin_bags_per_adult = (flight_offer) =>
  min_bags_across_segments(flight_offer, (fare_detail) => {
    const { includedCabinBags = {} } = fare_detail || {};
    return includedCabinBags.quantity || 0;
  });
